<template>
  <div class="w-full">
    <slot name="label" :for="id">
      <label :for="id" class="block text-xsm font-semibold text-typography-primary mb-1 subtext-text" v-if="label">
        {{ label }}
        <span v-if="required" class="text-red-600">*</span>
      </label>
    </slot>
    <slot name="label" :for="id" />
    <div>
      <textarea
        v-bind="$attrs"
        :id="id"
        :value="modelValue"
        v-hubble="'textarea'"
        @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
        :class="classes"
        resize="none"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: false,
  },
  id: {
    type: String,
    required: true,
  },
  error: {
    type: Boolean,
    default: false,
    required: false,
  },
  modelValue: {
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  styles: {
    type: String,
    default: '',
  },
  resize: {
    type: String,
    default: 'none',
  },
});

const classes = computed(() => {
  const classes = {
    'disabled:bg-neutral-200 disabled:text-typography-disabled disabled:cursor-not-allowed text-sm block w-full ring-inset py-3 rounded-lg focus:ring-primary-700 focus:ring-2 focus:outline-none font-normal text-typography-primary bg-neutral-white placeholder:text-typography-disabled px-4':
      true,
    'ring-2 ring-danger-700': props.error,
    'ring-1 ring-neutral-300': !props.error,
  };

  if (props.styles) classes[props.styles] = true;

  return classes;
});
</script>
